import React, { useState } from 'react';
import { Box, Button, Form, FormField, Grid, Input, SpaceBetween } from '@amzn/awsui-components-react';
import { useTranslation } from 'react-i18next';
import { i18nKeys } from '@/src/utils/i18n.utils';
import { JoinOrCreateTeamProps } from '@/src/types/JamJoinTeam';
import TeamListSelection from '../TeamListSelection/TeamListSelection';
import { JamTeamItem } from '@/src/types/JamTeam';
import { JamEventTeamAssignmentType } from '@/src/types/JamCommon';

interface JoinExistingTeamFormProps extends Omit<JoinOrCreateTeamProps, 'createTeam'> {
  teams: JamTeamItem[];
  teamAssignmentType: JamEventTeamAssignmentType;
}

const JoinExistingTeamForm: React.FC<JoinExistingTeamFormProps> = ({ teams, joinTeam, saving, teamAssignmentType }) => {
  const { t } = useTranslation();
  const [selectedTeam, setSelectedTeam] = useState<JamTeamItem[]>();
  const [selectedTeamError, setSelectedTeamError] = useState('');
  const [password, setPassword] = useState('');
  const [passwordError, setPasswordError] = useState('');

  const onSubmit = async () => {
    if (!selectedTeam?.length) {
      setSelectedTeamError(t(i18nKeys.joinTeam.joinExistingTeam.field.errors.teamError));
      return;
    }
    if (selectedTeam[0]?.team.passwordRequired && !password) {
      setPasswordError(t(i18nKeys.joinTeam.form.errors.password));
      return;
    }
    setSelectedTeamError('');
    setPasswordError('');
    await joinTeam(selectedTeam[0].team.teamName, password || null);
  };

  return (
    <form onSubmit={(e) => e.preventDefault()}>
      <Grid gridDefinition={[{ colspan: 9 }]}>
        <Form>
          <SpaceBetween direction="vertical" size="l">
            <Box margin={{ top: 'l' }}>{t(i18nKeys.joinTeam.joinExistingTeam.description)}</Box>
            <FormField stretch errorText={selectedTeamError}>
              <TeamListSelection
                items={teams}
                cardsPerRow={[{ cards: 3 }]}
                onSelectionChange={({ detail }) => {
                  setSelectedTeam(detail.selectedItems);
                  setSelectedTeamError('');
                }}
                selectedItems={selectedTeam}
                teamAssignmentType={teamAssignmentType}
              />
            </FormField>
            {!!selectedTeam?.[0]?.team.passwordRequired && (
              <FormField label={t(i18nKeys.general.password)} errorText={passwordError}>
                <Input
                  type="password"
                  value={password}
                  onChange={({ detail }) => setPassword(detail.value)}
                  data-testid="team-password-input"
                />
              </FormField>
            )}
            <div className="divider" />
            <Box float="right">
              <Button
                loading={saving}
                variant="primary"
                onClick={() => void onSubmit()}
                data-testid="join-specific-team-btn"
              >
                {t(i18nKeys.joinTeam.joinSpecificTeam.submitBtn)}
              </Button>
            </Box>
          </SpaceBetween>
        </Form>
      </Grid>
    </form>
  );
};

export default JoinExistingTeamForm;
